import { render, staticRenderFns } from "./PreviewSubmissionModal.vue?vue&type=template&id=508560fb&scoped=true&"
import script from "./PreviewSubmissionModal.vue?vue&type=script&lang=js&"
export * from "./PreviewSubmissionModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSubmissionModal.vue?vue&type=style&index=0&id=508560fb&scoped=true&lang=scss&"
import style1 from "./PreviewSubmissionModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508560fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508560fb')) {
      api.createRecord('508560fb', component.options)
    } else {
      api.reload('508560fb', component.options)
    }
    module.hot.accept("./PreviewSubmissionModal.vue?vue&type=template&id=508560fb&scoped=true&", function () {
      api.rerender('508560fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/PreviewSubmissionModal.vue"
export default component.exports